import React, { useRef, useState, useEffect } from "react"
import Layout from "@components/Layout"
import "@styles/components/form.scss"
import axios from "axios"

const NewsletterTest = () => {
  const emailField = useRef(null)

  const [isValid, setIsValid] = useState(false)
  const [email, setEmail] = useState("")
  const [showThankYouMessage, setShowThankYouMessage] = useState(false)
  const [showErrorMessage, setShowErrorMessage] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleEmailInput = e => {
    setEmail(e.target.value)
  }

  useEffect(() => {
    if (isValidEmail(email)) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [email])

  const createProfileInBraze = async email => {
    const body = {
      event_name: "newsletter_signup",
      email: email,
      email_subscribe: "opted_in",
      email_subscription_groups: {
        general_marketing: true,
        weekly_newsletter: true,
        surveys: true,
      },
    }

    const config = {
      headers: {
        "X-API-KEY": process.env.GATSBY_REGISTRATION_X_TOKEN,
      },
    }

    const trackAliasUrl = `${process.env.GATSBY_REGISTRATION_API}/registration/api/v1/customer/track-alias`

    try {
      const response = await axios.post(trackAliasUrl, body, config)
      if (response.status === 201) {
        setShowThankYouMessage(true)
        setShowErrorMessage(false)
        setIsLoading(false)
      } else {
        console.log(response)
        setShowThankYouMessage(false)
        setShowErrorMessage(true)
        setIsLoading(false)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const isValidEmail = email => {
    return /^.+@.+\..+$/.test(email)
  }

  const handleNewsletterSignup = () => {
    setIsLoading(true)
    createProfileInBraze(email)
  }
  return (
    <Layout>
      <section className="container">
        <div className="newsletter is-centered">
          <h1>Join the Odd Community</h1>
          {!showThankYouMessage && (
            <div>
              <p>
                Get a big bunch of Odd straight to your inbox each week -
                including recipes, tips and treats.
              </p>
              <div className="form">
                <input
                  ref={emailField}
                  onChange={handleEmailInput}
                  type="text"
                  name=""
                  id=""
                  value={email}
                  placeholder="Email address"
                  required
                />
                <p className="text-small">
                  By signing up for the newsletter, you agree to opt into Oddbox
                  General Marketing and Newsletters via Email.
                </p>

                <button
                  style={{ margin: "0 auto" }}
                  onClick={handleNewsletterSignup}
                  className="button button-primary"
                  value="signup"
                  disabled={isValid ? false : "disabled"}
                >
                  {isLoading && <div className="loader"></div>}
                  {!isLoading && <>Sign up</>}
                </button>
              </div>
            </div>
          )}
          {showThankYouMessage && (
            <div>
              <p className="underline">
                Thank you for signing up to our newsletter!
              </p>
            </div>
          )}
          {showErrorMessage && (
            <div>
              <p className="underline">
                Please ensure you have entered your Email address.
              </p>
            </div>
          )}
        </div>
      </section>
    </Layout>
  )
}

export default NewsletterTest
